import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from "@angular/common/http";
import { Injectable } from "@angular/core";
import StorageHelper from "@app/_core/helpers/storage.helper";
import { Observable } from "rxjs";

@Injectable({
	providedIn: "root",
})
export class HeaderInterceptor implements HttpInterceptor {
	intercept(req: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
		const newHeaders: {
			[name: string]: string | string[];
		} = {
			"Access-Control-Allow-Origin": "*",
			"Cache-Control": "no-cache",
			Pragma: "no-cache",
		};

		if (StorageHelper.getToken()) {
			newHeaders.Authorization = StorageHelper.getToken();
		}

		return next.handle(
			req.clone({
				setHeaders: newHeaders,
			}),
		);
	}
}
